import { ENABLE_SEPARATE_MEZO_CHAINS } from "./feature-flag"
import { IS_MEZO_MAINNET } from "./network"

export const ENABLE_MAINNET_MATS_REWARDS = ENABLE_SEPARATE_MEZO_CHAINS
  ? IS_MEZO_MAINNET
  : true

export const DISABLE_TESTNET_MATS_REWARDS = ENABLE_SEPARATE_MEZO_CHAINS
  ? !IS_MEZO_MAINNET
  : false
